export { ReactComponent as QuestionGroupList } from './svgs/question-group-list.svg';
